// extracted by mini-css-extract-plugin
export var inline = "_ui-0";